import React from "react";

const StatCard = ({ icon, value, label, textColor = "text-gray-900" }) => (
  <div className="bg-secondary rounded-xl p-3">
    <div className="flex flex-col">
      {icon && (
        <span className="bg-white w-6 h-6 text-center flex justify-center items-center rounded">
          {icon}
        </span>
      )}
      <div className={`text-2xl font-semibold mt-0 ${textColor}`}>{value}</div>
      <div className="text-gray-500 text-sm">{label}</div>
    </div>
  </div>
);

export default StatCard;
